import { memo } from 'react';

import { useStore } from '@spazious/dollhouse-store';
import { ToolModeEnum } from '@spazious/dollhouse-types';

import { PolygonDrawControls } from '../PolygonDrawControls/index.js';

export const FPolygonControls = memo(() => {
  const tool = useStore(({ tool }) => tool);

  const onDrawPolygon = () => {
    // TODO
  };

  return tool === ToolModeEnum.Draw ? <PolygonDrawControls onDraw={onDrawPolygon} /> : null;
});
